import React, {useState} from 'react';
import {NotificationManager} from 'react-notifications';
import {Col, Container, Row} from "react-bootstrap";
import verificarNif from "../../../utils/verifyNif";
import {Trans, useTranslation} from "react-i18next";

import Header from '../../../components/Header/Header';
import CheckBox from '../../../components/CheckBox/CheckBox';
import Button from '../../../components/Button/Button';
import BulletHeader from "../../../components/BulletHeader/BulletHeader";
import Input from "../../../components/Input";
import Swal from "sweetalert2";

import './styles.css';

const TournamentConditions = (props) => {
   const [billing_name, setBillingName] = useState('');
   const [nif, setNif] = useState('');
   const [accept_terms, setAcceptTerms] = useState(false);
   const [accept_contact, setAcceptContact] = useState(false);
   const [accept_share_data, setAcceptShareData] = useState(false);
   const [sending, setSending] = useState(false);
   const { t } = useTranslation();

   const submit = (data) => {
      let partnerName = props.formData.partner_registration ? ` - ${props.formData.partner_registration.name}` : "";

      if (verifyData()) {
         Swal.fire({
            allowOutsideClick: false,
            showCancelButton: true,
            titleText: t("registration_page.confirmation_popup.title"),
            html: `${t("registration_page.confirmation_popup.content")}<br><br><strong>${props.formData.name}<br>
            ${props.formData.category_name}<br>${props.formData.user_registration.name}${partnerName}</strong>`,
            confirmButtonText: t("common.yes"),
            cancelButtonText: t("registration_page.confirmation_popup.fix")
         }).then((res) => {
            if (res.dismiss === Swal.DismissReason.cancel) {
               Swal.close();
            } else {
               if (!sending) {
                  setSending(true);
                  props.onSubmit(data);
               }
            }
         });
      }
   };

   const verifyData = () => {
      let isAcceptable = true;

      if(nif !== '' && billing_name === ''){
         isAcceptable = false;
         NotificationManager.error(
            t("registration_page.errors.billing_name_mandatory"),
            t("common.error"),
            4000,
         );
         return isAcceptable;
      }

      if(billing_name !== '' && nif === ''){
         isAcceptable = false;
         NotificationManager.error(
            t("registration_page.errors.billing_nif_mandatory"),
            t("common.error"),
            4000,
         );
         return isAcceptable;
      }

      if (nif !== '' && !verificarNif(nif)) {
         isAcceptable = false;
         NotificationManager.error(
            t("registration_page.errors.billing_nif_invalid"),
            t("common.error"),
            4000,
         );
         return isAcceptable;
      }

      if (!accept_terms) {
         isAcceptable = false;
         NotificationManager.error(
            t("registration_page.errors.disclaimer_accept_regulation"),
            t("common.error"),
            4000,
         );
         return isAcceptable;
      }

      if (!accept_contact) {
         isAcceptable = false;
         NotificationManager.error(
            t("registration_page.errors.disclaimer_contact_mandatory"),
            t("common.error"),
            4000,
         );
         return isAcceptable;
      }

      return isAcceptable;
   }

   return (
      <div>
         <Header headerBarTitle={t("registration_page.header")} showHeaderExtras showBackButton/>

         <Container>
            <Row>
               <Col xs={12}>
                  <CheckBox
                     handleChange={() => setAcceptTerms(!accept_terms)}
                     id="accept_terms"
                     checked={accept_terms}
                     name="accept_terms"
                  >
                     {`${t("registration_page.disclaimer.accept_regulation_1")} `}
                     <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={props.formData.terms_url}
                     >
                        {`${t("registration_page.disclaimer.accept_regulation_2")} `}
                     </a>
                     {t("registration_page.disclaimer.accept_regulation_3")}
                  </CheckBox>
                  <CheckBox
                     handleChange={() => setAcceptContact(!accept_contact)}
                     id="accept_contact"
                     checked={accept_contact}
                     name="accept_contact"
                     text={t("registration_page.disclaimer.share_contacts_tournament")}
                  />
                  <CheckBox
                     handleChange={() => setAcceptShareData(!accept_share_data)}
                     id="accept_share_data"
                     checked={accept_share_data}
                     name="accept_share_data"
                  >
                     <Trans i18nKey="registration_page.disclaimer.share_info" components={{ strong: <strong /> }} />
                  </CheckBox>
               </Col>
            </Row>

            <Row>
               <Col xs={12} className={"pb-2"}>
                  <BulletHeader text={t("registration_page.billing")}/>
                  <Input handleChange={(e) => setBillingName(e.target.value)} name="billing_name" inputType="text" text={t("registration_page.billing_alert")} placeHolder={t("registration_page.billing_name")} inputTextValue={billing_name}/>
                  <Input style={{marginTop: -20}} handleChange={(e) => setNif(e.target.value)} name="nif" inputType="text" placeHolder={t("registration_page.billing_nif")} inputTextValue={nif}/>
               </Col>
            </Row>

            <Row>
               <Col xs={12} sm={{span: 6, offset: 3}} className={"pt-3"}>
                  <Button
                     onClick={() => submit({
                        info_and_conditions: {
                           billing_name,
                           nif,
                           accept_terms,
                           accept_contact,
                           accept_share_data
                        }
                     })}
                     className={"mt-0 mb-4 w-100 btn btn-primary"} variant="secondary"
                     disabled={sending}>
                     {sending ? t("common.please_wait") : t("registration_page.submit_registration")}
                  </Button>
               </Col>
            </Row>
         </Container>
      </div>
   );
}

export default TournamentConditions;
